// extracted by mini-css-extract-plugin
module.exports = {"switchPageBtn":"switchpageitem_switchPageBtn__TNtAk","xs":"switchpageitem_xs__35lWp"};